import React, { useState, useRef } from "react";
import OuterHeader from "../../components/OuterHeader";
import Footer from "../../components/Footer";
import "../../css2/RuralWellness.css";
import HelprrGroundingOrb from "../../components/HelprrGroundingOrb";
import HelprrBodyExercise from "../../components/HelprrBodyExercise";
import HelprrSensoryGrounding from "../../components/HelprrSensoryGrounding";
/* -----------------------------
   SUPPORT OPTIONS
----------------------------- */

const SUPPORT_OPTIONS = [
  {
    id: "worn",
    title: "Feeling worn down",
    description: "Low energy. Carrying too much. Running on empty.",
  },
  {
    id: "disconnected",
    title: "Feeling disconnected",
    description: "Lonely. Far from people. Quiet feels heavy.",
  },
  {
    id: "overwhelmed",
    title: "Feeling overwhelmed",
    description: "Mind racing. Body tight. Too much at once.",
  },
  {
    id: "steady",
    title: "Just checking in",
    description: "No crisis. Staying regulated.",
  },
];

/* -----------------------------
   TOOLKIT CONTENT
----------------------------- */

const TOOLKIT_BY_FOCUS = {
  worn: {
    intro:
      "When you’re worn down, your system needs restoration before problem-solving.",
    tools: [
      {
        type: "grounding",
        title: "Grounding reset",
        subtitle: "Let your body slow down before doing anything else.",
      },
      {
        type: "body",
        title: "Micro body release",
        // intro: "Take this slowly. There’s nothing to get right.",
        steps: [
          {
            text: "If it feels okay, let your shoulders drop by about 10%.",
            hint: "Not all the way. Just a little.",
          },
          {
            text: "Let your jaw soften.",
            hint: "Your teeth don’t need to touch.",
          },
          {
            text: "Press your feet gently into the floor.",
            hint: "Notice the support underneath you.",
          },
          {
            text: "Take one slow breath out.",
            hint: "Longer out if it feels natural.",
          },
        ],
        endNote: "Even one small release helps your system reset.",
      },
      
      {
        type: "reflection",
        title: "Energy check",
        prompts: [
          "What has been taking the most energy lately?",
          "What gives even 5% back?",
        ],
      },
    ],
  },

  disconnected: {
    intro:
      "Distance doesn’t mean something is wrong with you. These tools focus on gentle connection.",
    tools: [
      {
        type: "grounding",
        title: "Settling into presence",
        subtitle: "Connection starts with being here.",
      },
      {
        type: "reflection",
        title: "Connection without pressure",
        prompts: [
          "Who feels safest in my world?",
          "What places make me feel less alone?",
        ],
      },
      {
        type: "info",
        content:
          "Rural isolation is environmental, not personal. Fewer spontaneous interactions make loneliness linger longer.",
      },
    ],
  },

  overwhelmed: {
    intro:
      "Overwhelm is your system asking for fewer inputs — not a failure.",
    tools: [
      {
        type: "grounding",
        title: "Slow the system",
        subtitle: "Let the pace drop before thinking.",
      },
      {
        type: "steps",
        title: "5-4-3-2-1 grounding",
        steps: [
          "Name 5 things you see",
          "4 things you feel",
          "3 things you hear",
          "2 things you smell",
          "1 thing you’re grateful for",
        ],
      },
      {
        type: "info",
        content:
          "Cognitive clarity returns faster after the body feels safe.",
      },
    ],
  },

  steady: {
    intro:
      "Checking in early protects your energy and prevents burnout.",
    tools: [
      {
        type: "grounding",
        title: "Steady check-in",
        subtitle: "Notice what’s working.",
      },
      {
        type: "reflection",
        title: "Protecting steadiness",
        prompts: [
          "What’s helping me stay regulated?",
          "What do I want to protect this week?",
        ],
      },
    ],
  },
};
const ORB_MODE_BY_FOCUS = {
    worn: "grounding",        // warm, restoring
    disconnected: "release",  // cool, flowing
    overwhelmed: "release",   // calming, de-load
    steady: "steady",         // balanced, structured
  };
  
/* -----------------------------
   COMPONENT
----------------------------- */

export default function RuralWellness() {
  const [focus, setFocus] = useState(null);
  const current = focus ? TOOLKIT_BY_FOCUS[focus] : null;
  const exerciseRef = useRef(null);
  return (
    <>
      <OuterHeader />

      <main className="rw-page">
        {/* HERO */}
        <section className="rw-hero">
          <div>
            <div className="rw-partner">
              Helprr × Wellness on Wheels — South Eastern New Brunswick
            </div>
            <h1>
              Rooted in community.
              <br />
              Connected by care.
            </h1>
            <p className="rw-hero-sub">
            Wellness on Wheels & Helprr have partnered to bring mental health support directly to you, 
            bridging the distance with tools tailored for rural life.
            </p>
          </div>
        </section>

        {/* CHOICE */}
        <section className="rw-choice">
          <h2 style={{ color: "#F16A37" }}>Where would support help most today?</h2>
          <p className="rw-choice-sub">Choose one. Nothing is saved.</p>

          <div className="rw-options">
  {SUPPORT_OPTIONS.map(o => (
    <button
      key={o.id}
      className={`rw-option ${focus === o.id ? "active" : ""}`}
      onClick={() => {
        setFocus(o.id);

        // Smoothly scroll to the toolkit section
        setTimeout(() => {
          exerciseRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100);
      }}
    >
      <strong>{o.title}</strong>
      <span>{o.description}</span>
    </button>
  ))}
</div>

        </section>

        {/* TOOLKIT */}
        {current && (
          <section className="rw-tools"ref={exerciseRef}>
            <p style={{ opacity: 0.75, marginBottom: 20 }}>
              {current.intro}
            </p>

            {current.tools.map((tool, idx) => (
              <div key={idx} className="rw-tool-card">


                {tool.type === "grounding" && (
                  <HelprrGroundingOrb
                    title={tool.title}
                    subtitle={tool.subtitle}
                    mode={ORB_MODE_BY_FOCUS[focus]}
                  />
                )}
                {tool.type === "body" && (
  <HelprrBodyExercise
    title={tool.title}
    intro={tool.intro}
    steps={tool.steps}
    endNote={tool.endNote}
  />
)}
                {/* {tool.type === "steps" && (
                  <>
                    <strong>{tool.title}</strong>
                    <ul>
                      {tool.steps.map((s, i) => (
                        <li key={i}>{s}</li>
                      ))}
                    </ul>
                  </>
                )} */}
                {tool.type === "steps" && tool.title.includes("5-4-3-2-1") && (
  <HelprrSensoryGrounding />
)}


                {tool.type === "reflection" && (
                  <>
                    <strong>{tool.title}</strong>
                    <ul>
                      {tool.prompts.map((p, i) => (
                        <li key={i}>{p}</li>
                      ))}
                    </ul>
                  </>
                )}

                {tool.type === "info" && (
                  <p style={{ opacity: 0.75 }}>{tool.content}</p>
                )}
              </div>
            ))}
          </section>
        )}

        <footer className="rw-footer">
          One small pause is enough.
        </footer>
      </main>

      <Footer />
    </>
  );
}
